<!-- FikoKutukComponent - Dialog Core içinde render ediliyor -->
<div style="width:100%;min-width:300px;padding:8px;">
    <input class="fikoinput" type="text" #inputKutukIsim placeholder="İsmi" [ngModel]="kutuk?.name"
            (ngModelChange)="kutuk.name=inputKutukIsim.value;this.FikoYT.degisti.emit();"
            style="margin-bottom:4px;font-size:12px;padding:5px;">

    <textarea class="fikoinputAciklama" #inputKutukAciklama placeholder="Açıklaması"
        [ngModel]="kutuk?.userData?.aciklama"
        (ngModelChange)="kutuk.userData.aciklama=inputKutukAciklama.value;this.FikoYT.degisti.emit();"
        style="margin-bottom:6px;font-size:11px;padding:5px;resize:vertical;min-height:40px;max-height:70px;"></textarea>

    <!-- Kütük Ayarları -->
    <div style="padding-top:6px;border-top:1px solid #e0e0e0;font-size:12px;">

        <!-- İki Eksen Seçim Modu -->
        <label style="display:flex;align-items:center;cursor:pointer;margin-bottom:4px;font-size:12px;">
            <input type="checkbox" [checked]="kutuk?.twoAxisMode"
                (change)="toggleTwoAxisMode()"
                style="margin-right:5px;cursor:pointer;">
            <span style="font-weight:500;">2 Eksen</span>
        </label>

        <div *ngIf="kutuk?.twoAxisMode" style="margin-bottom:4px;padding:4px;background-color:#e3f2fd;border-radius:3px;font-size:11px;">
            <div><strong>{{ kutuk?.selectedAxes?.length }}/2</strong></div>
            <div *ngIf="kutuk?.selectedAxes?.length === 0">👆 Yüzeye tıkla</div>
            <div *ngIf="kutuk?.selectedAxes?.length === 1">👆 2. yüzeye tıkla</div>
            <div *ngIf="kutuk?.selectedAxes?.length === 2">✅ Seçildi</div>
            <button *ngIf="kutuk?.selectedAxes?.length > 0" (click)="resetAkseler()"
                class="ui mini button" style="width:100%;margin-top:3px;padding:4px 8px;font-size:11px;">
                Sıfırla
            </button>
        </div>

        <!-- Stock Oluştur -->
        <button *ngIf="!kutuk?.roughStockResult" (click)="roughStockOlusturCizimIcin()"
            class="ui mini button" style="width:100%;margin-bottom:4px;padding:4px 8px;font-size:11px;">
            Stock Oluştur
        </button>

        <!-- Yüzey Seçimi Bilgisi (2 Eksen modu devre dışı olduğunda) -->
        <div *ngIf="kutuk?.roughStockResult && !kutuk?.twoAxisMode && kutuk?.secilenFaceNormal"
            style="margin-bottom:4px;padding:4px;background-color:#c8e6c9;border-radius:3px;font-size:10px;">
            <div><strong>✓ Yüzey:</strong> ({{ kutuk?.secilenFaceNormal?.x?.toFixed(4) }}, {{ kutuk?.secilenFaceNormal?.y?.toFixed(4) }}, {{ kutuk?.secilenFaceNormal?.z?.toFixed(4) }})</div>
            <button (click)="resetYuzeySecimi()"
                class="ui mini button" style="width:100%;margin-top:3px;padding:4px 8px;font-size:11px;">
                Seçimi Sıfırla
            </button>
        </div>

        <!-- Yüzey Seç Talimatı (2 Eksen modu devre dışı olduğunda) -->
        <div *ngIf="kutuk?.roughStockResult && !kutuk?.twoAxisMode && !kutuk?.secilenFaceNormal"
            style="margin-bottom:4px;padding:4px;background-color:#fff9c4;border-radius:3px;font-size:10px;">
            <strong>💡:</strong> Yüzeye tıkla
        </div>

        <!-- Renk ve Şeffaflık (Yan Yana) -->
        <div style="margin-bottom:4px;display:flex;gap:6px;align-items:flex-end;">
            <div style="flex:0 0 50px;">
                <div style="margin-bottom:2px;font-size:11px;">Renk:</div>
                <input type="color"
                    [value]="'#' + kutuk?.roughStockOptions?.color?.toString(16)?.padStart(6, '0')"
                    (change)="renkGuncelle($any($event.target).value)"
                    style="width:100%;height:28px;cursor:pointer;border:none;border-radius:3px;">
            </div>
            <div style="flex:1;">
                <div style="margin-bottom:2px;font-size:11px;">Şeffaflık: {{ (kutuk?.roughStockOptions?.opacity * 100)?.toFixed(0) }}%</div>
                <input type="range" min="0" max="1" step="0.05"
                    [ngModel]="kutuk?.roughStockOptions?.opacity"
                    (change)="opacityGuncelle(parseFloat($any($event.target).value))"
                    style="width:100%;height:18px;">
            </div>
        </div>

        <!-- Stock Boyutu -->
        <div *ngIf="kutuk?.roughStockResult" style="margin-bottom:4px;padding:4px;background-color:#f5f5f5;border-radius:3px;font-size:10px;">
            <div><strong>Boyutlar:</strong></div>
            <div>X: {{ getSortedSizes().large?.toFixed(4) }} | Y: {{ getSortedSizes().medium?.toFixed(4) }} | Z: {{ getSortedSizes().small?.toFixed(4) }}</div>
        </div>

    </div>

    <!-- Alt Butonlar (Yan Yana) -->
    <div style="display:flex;gap:6px;margin-top:6px;">
        <button *ngIf="kutuk?.roughStockResult" (click)="stockuKaldir()"
            class="ui mini button negative" style="flex:1;padding:6px 8px;font-size:11px;">
            Stock Kaldır
        </button>
        <button (click)="kapa()"
            class="ui mini button" style="flex:1;padding:6px 8px;font-size:11px;">
            Kapat
        </button>
    </div>
</div>
